import { Component, ViewChild, inject } from "@angular/core";
import { AnalyticsService } from "./services/analytics/analytics.service";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import {
  FlexColumnComponent,
  GrowDirective,
  ScrollDirective,
} from "@apexdesigner/flex-layout";
import { ApexLogoComponent } from "@components/apex-logo/apex-logo.component";
import { SiteFooterComponent } from "@components/site-footer/site-footer.component";
import { AdElDirective } from "./directives/ad-el/ad-el.directive";

/**
 * App
 *
 * Root application component. Hosts the sticky pill nav, the routed page
 * content, and the global footer. The nav and footer are global per the
 * handoff (rendered once, outside the page containers).
 *
 * Scrolls the inner scroll container to the top whenever the router-outlet
 * activates a new page, so visitors always land at the top after clicking
 * a nav link. The `[scroll]` directive from @apexdesigner/flex-layout
 * sets `overflow-y: auto` on this div, so it — not `window` — is the
 * scroll container.
 */
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  host: { adComp: "" },
  imports: [
    AdElDirective,
    ApexLogoComponent,
    FlexColumnComponent,
    GrowDirective,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    ScrollDirective,
    SiteFooterComponent,
  ],
})
export class AppComponent {
  analyticsService = inject(AnalyticsService);

  /** Reference to the inner scrollable div — used to scroll back to top on page change. */
  @ViewChild("scrollContainer")
  scrollContainer!: HTMLDivElement;

  /** Whether the mobile menu drawer is open. Desktop nav ignores this. */
  mobileMenuOpen = false;

  /** Toggle the mobile menu drawer. */
  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  /** Close the mobile menu — wired to every drawer link so navigation collapses the menu. */
  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  /** Mobile drawer booking CTA — close the menu and record the click. */
  bookFromMobileNav(): void {
    this.closeMobileMenu();
    this.analyticsService.trackBookCta("mobile-nav");
  }
}
